/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdminUserAccount } from '../models/AdminUserAccount';
import type { AgentUser } from '../models/AgentUser';
import type { Artist } from '../models/Artist';
import type { ArtistUser } from '../models/ArtistUser';
import type { BarUser } from '../models/BarUser';
import type { BreweryUser } from '../models/BreweryUser';
import type { CorporateEventUser } from '../models/CorporateEventUser';
import type { CountryclubUser } from '../models/CountryclubUser';
import type { GreekUser } from '../models/GreekUser';
import type { ManagerUser } from '../models/ManagerUser';
import type { MunicipalUser } from '../models/MunicipalUser';
import type { NightclubUser } from '../models/NightclubUser';
import type { OtherSellerUser } from '../models/OtherSellerUser';
import type { RestaurantUser } from '../models/RestaurantUser';
import type { UPBUser } from '../models/UPBUser';
import type { UserAccount } from '../models/UserAccount';
import type { UserRole } from '../models/UserRole';
import type { WeddingUser } from '../models/WeddingUser';
import { request as __request } from '../core/request';

export class AdminUserCallsService {

    /**
     * Get User
     * @param userId
     * @result AdminUserAccount | AgentUser | ArtistUser | BarUser | BreweryUser | CorporateEventUser | CountryclubUser | GreekUser | ManagerUser | MunicipalUser | NightclubUser | OtherSellerUser | RestaurantUser | UPBUser | WeddingUser Successful Response
     * @throws ApiError
     */
    public static async getUser({
        userId,
    }: {
        userId: string,
    }
): Promise<AdminUserAccount | AgentUser | ArtistUser | BarUser | BreweryUser | CorporateEventUser | CountryclubUser | GreekUser | ManagerUser | MunicipalUser | NightclubUser | OtherSellerUser | RestaurantUser | UPBUser | WeddingUser> {
    const result = await __request({
        method: 'GET',
        path: `/admin_user_calls/get_user`,
        query: {
            'user_id': userId,
        },
        errors: {
            422: `Validation Error`,
        },
    });
    return result.body;
}

/**
 * Get Users
 * @param limit
 * @param userRole
 * @param lastDocId
 * @result AdminUserAccount | AgentUser | ArtistUser | BarUser | BreweryUser | CorporateEventUser | CountryclubUser | GreekUser | ManagerUser | MunicipalUser | NightclubUser | OtherSellerUser | RestaurantUser | UPBUser | WeddingUser Successful Response
 * @throws ApiError
 */
public static async getUsers({
    limit,
    userRole,
    lastDocId,
}: {
    limit?: number,
    userRole?: UserRole,
    lastDocId?: string,
}
): Promise<Array<AdminUserAccount | AgentUser | ArtistUser | BarUser | BreweryUser | CorporateEventUser | CountryclubUser | GreekUser | ManagerUser | MunicipalUser | NightclubUser | OtherSellerUser | RestaurantUser | UPBUser | WeddingUser>> {
    const result = await __request({
        method: 'GET',
        path: `/admin_user_calls/get_users`,
        query: {
            'limit': limit,
            'user_role': userRole,
            'last_doc_id': lastDocId,
        },
        errors: {
            422: `Validation Error`,
        },
    });
    return result.body;
}

/**
 * Approve User
 * @param userId
 * @result AdminUserAccount | AgentUser | ArtistUser | BarUser | BreweryUser | CorporateEventUser | CountryclubUser | GreekUser | ManagerUser | MunicipalUser | NightclubUser | OtherSellerUser | RestaurantUser | UPBUser | WeddingUser Successful Response
 * @throws ApiError
 */
public static async approveUser({
    userId,
}: {
    userId: string,
}
): Promise<AdminUserAccount | AgentUser | ArtistUser | BarUser | BreweryUser | CorporateEventUser | CountryclubUser | GreekUser | ManagerUser | MunicipalUser | NightclubUser | OtherSellerUser | RestaurantUser | UPBUser | WeddingUser> {
    const result = await __request({
        method: 'PATCH',
        path: `/admin_user_calls/approve_user`,
        query: {
            'user_id': userId,
        },
        errors: {
            422: `Validation Error`,
        },
    });
    return result.body;
}

/**
 * Disapprove User
 * @param userId
 * @result AdminUserAccount | AgentUser | ArtistUser | BarUser | BreweryUser | CorporateEventUser | CountryclubUser | GreekUser | ManagerUser | MunicipalUser | NightclubUser | OtherSellerUser | RestaurantUser | UPBUser | WeddingUser Successful Response
 * @throws ApiError
 */
public static async disapproveUser({
    userId,
}: {
    userId: string,
}
): Promise<AdminUserAccount | AgentUser | ArtistUser | BarUser | BreweryUser | CorporateEventUser | CountryclubUser | GreekUser | ManagerUser | MunicipalUser | NightclubUser | OtherSellerUser | RestaurantUser | UPBUser | WeddingUser> {
    const result = await __request({
        method: 'PATCH',
        path: `/admin_user_calls/disapprove_user`,
        query: {
            'user_id': userId,
        },
        errors: {
            422: `Validation Error`,
        },
    });
    return result.body;
}

/**
 * Edit Full User
 * @param requestBody
 * @result AdminUserAccount | AgentUser | ArtistUser | BarUser | BreweryUser | CorporateEventUser | CountryclubUser | GreekUser | ManagerUser | MunicipalUser | NightclubUser | OtherSellerUser | RestaurantUser | UPBUser | WeddingUser Successful Response
 * @throws ApiError
 */
public static async editFullUser({
    requestBody,
}: {
    requestBody: UserAccount,
}
): Promise<AdminUserAccount | AgentUser | ArtistUser | BarUser | BreweryUser | CorporateEventUser | CountryclubUser | GreekUser | ManagerUser | MunicipalUser | NightclubUser | OtherSellerUser | RestaurantUser | UPBUser | WeddingUser> {
    const result = await __request({
        method: 'PUT',
        path: `/admin_user_calls/edit_full_user`,
        body: requestBody,
        errors: {
            422: `Validation Error`,
        },
    });
    return result.body;
}

/**
 * Delete User
 * @param userId
 * @result boolean Successful Response
 * @throws ApiError
 */
public static async deleteUser({
    userId,
}: {
    userId: string,
}
): Promise<boolean> {
    const result = await __request({
        method: 'DELETE',
        path: `/admin_user_calls/delete_user`,
        query: {
            'user_id': userId,
        },
        errors: {
            422: `Validation Error`,
        },
    });
    return result.body;
}

/**
 * Publish Artist
 * @param artistId
 * @param unpublish
 * @result Artist Successful Response
 * @throws ApiError
 */
public static async publishArtist({
    artistId,
    unpublish = false,
}: {
    artistId: string,
    unpublish?: boolean,
}
): Promise<Artist> {
    const result = await __request({
        method: 'PATCH',
        path: `/admin_user_calls/publish_artist`,
        query: {
            'artist_id': artistId,
            'unpublish': unpublish,
        },
        errors: {
            422: `Validation Error`,
        },
    });
    return result.body;
}

}